import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledExclamationIcon = styled(FontAwesomeIcon)`
  && {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.error.main};
  }
`;

export const StyledMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;
